import m from "mithril";
import { PortalForm } from "../types/portal-form.interface";

export const Form: m.Component<{
  form: PortalForm,
  disabled?: boolean,
}, {}> = {

  view({ attrs }) {
    const form = attrs.form;
    const disabled = attrs.disabled === true;

    return m("flex.flex-col.space-y-4.", [

      m(".flex.flex-col.space-y-1", [
        m("label.font-semibold", "Project"),
        m("input.input", {
          disabled: true,
          value: form.projectName,
          oninput: (e: any) => form.projectName = e.target.value,
        }),
      ]),

      (form.songName !== form.projectName) ? m(".flex.flex-col.space-y-1", [
        m("label.font-semibold", "Song"),
        m("input.input", {
          disabled: true,
          value: form.songName,
          oninput: (e: any) => form.songName = e.target.value,
        }),
      ]) : [],

      m(".flex.flex-col.space-y-1", [
        m("label.font-semibold", "Voice Part"),
        m("input.input", {
          disabled: true,
          value: form.partName,
          oninput: (e: any) => form.partName = e.target.value,
        }),
      ]),

      m(".flex.flex-col.space-y-1", [
        m("label.font-semibold", "Email Address"),
        m("input.input", {
          disabled,
          value: form.email,
          oninput: (e: any) => form.email = e.target.value,
        }),
      ]),

      m(".flex.flex-col.space-y-1", [

        m(".flex.flex-col.sm:flex-row.space-y-2.sm:space-y-0.sm:space-x-2", [
          m(".flex-1.flex.flex-col.space-y-1", [
            m("label.font-semibold", "First Name"),
            m("input.input", {
              disabled,
              value: form.givenName,
              oninput: (e: any) => form.givenName = e.target.value,
            }),
          ]),

          m(".flex-1.flex.flex-col.space-y-1", [
            m("label.font-semibold", "Last Name"),
            m("input.input", {
              disabled,
              value: form.familyName,
              oninput: (e: any) => form.familyName = e.target.value,
            }),
          ]),
        ]),

        m("p.text-sm.text-gray-600", "Please check the spelling of your name and fix any mistakes as it will be used in the credits."),
      ]),

    ]);

  }

};
